import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import PolygonReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/polygon.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(PolygonReducer, defaultState, asyncActions);
};

type IPolygonContext = ReturnType<typeof useReducer>;

// Having trouble setting inital values, that's why it is cast to the return type of the reducer
const PolygonContext = createContext<Partial<IPolygonContext>>({
  state: defaultState,
}) as React.Context<IPolygonContext>;

const PolygonProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <PolygonContext.Provider value={{ ...reducer }}>
      {children}
    </PolygonContext.Provider>
  );
};

// We create context hook here so that we can be able to unit test
// container comonents that uses this context
export const usePolygonContext = () => useContext(PolygonContext);

export type IUsePolygonContext = ReturnType<typeof usePolygonContext>;

export { PolygonContext, PolygonProvider };
